import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from "../services/loader/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    constructor(public loaderService: LoaderService) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //this.loaderService.show();
        //return next.handle(req).pipe(
        //    finalize(() => this.loaderService.hide())
      //);
      const skip = req.headers.has('X-Skip-Loader');
      const cleanReq = skip ? req.clone({ headers: req.headers.delete('X-Skip-Loader') }) : req;

      if (!skip) this.loaderService.show();
      return next.handle(cleanReq).pipe(finalize(() => { if (!skip) this.loaderService.hide(); }));
    }
}
